import { api } from 'utils';

import {
  FetchGlobalClaimsApiResponse,
  GlobalClaimsParams,
} from './GlobalClaims.types';

export function fetchGlobalClaimsApi({ queryKey }: any) {
  const [, , params] = queryKey as [string, string, GlobalClaimsParams];

  return api().get<FetchGlobalClaimsApiResponse>(
    '/endorsement/health-claims/global',
    {
      params: {
        // Sent only when set, so an empty box is no filter rather than a
        // filter on the empty string.
        search: params.search || undefined,
        stage: params.stage || undefined,
        category: params.category || undefined,
        startDate: params.startDate || undefined,
        endDate: params.endDate || undefined,
        first: params.first,
        rows: params.rows,
      },
    }
  );
}
